export default __webpack_public_path__ + "static/media/Path -2@2x.181ab32a.png";